export default "__VITE_ASSET__BiHZVL$e__"